export function StandaloneTools() {
  return null;
}
